<template>
  <v-container>
    <v-card class="elevation-3 mt-3">
      <v-container class="pt-0">
        <v-layout row wrap>
          <v-flex xs12>
            <v-toolbar
              color="white"
              text
              class="mt-0 pt-0 elevation-0">
              <v-toolbar-title
                class="
                subtitle-1
                font-weight-medium">
                Nova Regra
              </v-toolbar-title>
            </v-toolbar>
          </v-flex>

          <v-flex xs8>
            <v-card-text>
              <v-form
                ref="form"
                lazy-validation
                class="pl-12 pr-12">
                <v-layout row wrap>
                  <v-flex md12>
                    <div
                      class="
                      mb-12
                      title
                      font-weight-regular">
                      Detalhes
                    </div>
                  </v-flex>
                  <v-flex md4>
                    <div class="
                    subtitle-1
                    font-weight-regular
                    blue--text
                    text--darken-4">Nome</div>
                  </v-flex>
                  <v-flex md8>
                    <v-text-field
                      outlined
                      clearable
                      placeholder="Nome da regra"
                      v-model="name"
                      :rules="nameRules"
                      dense
                      required
                      type="text"
                      color="teal accent-3"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md4>
                    <div class="
                    subtitle-1
                    font-weight-regular
                    blue--text
                    text--darken-4">Nome de exibição</div>
                  </v-flex>
                  <v-flex md8>
                  <v-text-field
                    outlined
                    clearable
                    placeholder="Nome de exibição da regra"
                    v-model="display_name"
                    :rules="nameRules"
                    dense
                    required
                    type="text"
                    color="teal accent-3"
                  ></v-text-field>
                  </v-flex>
                  <v-flex md4>
                    <div class="
                      subtitle-1
                      font-weight-regular
                      blue--text
                      text--darken-4">Descrição</div>
                  </v-flex>
                  <v-flex md8>
                  <v-text-field
                    outlined
                    clearable
                    placeholder="Descrição da regra"
                    v-model="description"
                    :rules="nameRules"
                    dense
                    required
                    type="text"
                    color="teal accent-3">
                  </v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-btn
                    class="body-2 white--text"
                    @click="addRule"
                    color="primary"
                    depressed>
                    Adicionar Regra
                  </v-btn>
                </v-layout>
              </v-form>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import { mask } from "vue-the-mask";
export default {
  name: "NewRule",
  directives: { mask },
  data: () => ({
    name: '',
    display_name:'',
    description:'',
    status: true,
    nameRules: [
      v => !!v || 'Campo é obrigatório',
    ],
    atendimento:false,
    medico:false,
    administrador:false,
    operador:false,
    email: undefined,
    password: undefined,
    show_password: false,
    loading: undefined,
  }),
  methods: {

    async addRule (){
      if(this.$refs.form.validate()){
        console.log(this.name, this.display_name, this.description, this.status);
        let rule = {
          name: this.name,
          display_name: this.display_name,
          status: this.status,
          description: this.description,
        };
        await this.$store.dispatch("addNewRule",rule)
          .then( resolve => {
            this.loading = false
            if(resolve.status){
              this.$refs.form.resetValidation()
              this.$refs.form.reset()
              this.$router.back()
            }
            else{
              console.log(resolve)
              if (resolve.response) {
                this.setErrorSave(resolve.response.data.message);
              }
              else if (resolve.request) {
                this.setErrorSave(resolve.request.response.data.message);
              }
              else {
                this.setErrorSave(resolve.message);
              }
            }
          })
          .catch( error => {
            this.setErrorSave(error.message);
            console.log(error)
            this.loading = false
          })
      }
    },

    setErrorSave (errorMsg) {
      this.textError = errorMsg;
    },
  }
};
</script>

<style>
</style>
